module.exports = __webpack_public_path__ + "static/radio-c9bb1305f0b503f57a58278da56ea097.png";